import { FILTER_OPERATIONS, FilterType } from "../../../types/Filter";
import { IconX } from "@tabler/icons-react";
import { useSmartOptions } from "../../../fetch/fetch.item";
import ErrMessage from "../../core/ErrMessage";
import LoadingInput from "../../core/loading/LoadingInput";
import { useSearchParamsHandler } from "../../../hooks/useSearchParamsHandler";
import { useActiveParams } from "../../../hooks/useActiveParams";
import { decode, encode } from "./SingleFilter";
import { FilterQueryValue } from "../../../types/ItemQuery.ts";

const MultiFilter = ({ filter }: { filter: FilterType }) => {
  const { add, get, remove } = useSearchParamsHandler("filter");
  const { categorySlug } = useActiveParams();

  const { options, isLoading, isError } = useSmartOptions(
    categorySlug,
    filter._id,
    [],
  );

  const getCurrentValue = (filterId: string) => {
    const active = get().find((val) => {
      const test = decode(val);
      if (!test) return false;
      return test._id === filterId;
    });
    if (!active) return false;

    return decode(active);
  };

  const setActive = (value: string | number) => {
    const current = getCurrentValue(filter._id);
    if (!current) {
      add(
        encode({
          _id: filter._id,
          value: [value],
          option: FILTER_OPERATIONS.IN,
        }),
      );
      return;
    }
    if (!Array.isArray(current.value)) {
      console.error("Error in filter, should be Array for Multi. ");
      return;
    }
    remove(encode(current));
    add(
      encode({
        ...current,
        value: [...current.value, value],
        option: FILTER_OPERATIONS.IN,
      }),
    );
  };

  const removeActive = (value: string | number) => {
    const current = getCurrentValue(filter._id);
    if (!current) return;
    remove(encode(current));

    if (Array.isArray(current.value)) {
      if (current.value.length === 1) {
        return;
      }
      add(
        encode({
          ...current,
          value: current.value.filter((val: FilterQueryValue) => val !== value),
        }),
      );
      return;
    }
  };

  const clearFilter = () => {
    get(filter._id).forEach((val) => remove(val));
  };

  if (isLoading) return <LoadingInput />;
  if (isError) return <ErrMessage message={isError.message} />;

  const activeValue = getCurrentValue(filter._id);
  const validValues =
    activeValue && Array.isArray(activeValue.value) ? activeValue.value : null;

  return (
    <div className="flex flex-wrap gap-2">
      {options.map((option) => {
        if (validValues?.some((val) => val === option)) {
          return (
            <button
              key={option}
              className="btn btn-info active:btn-neutral"
              onClick={() => removeActive(option)}
            >
              <IconX /> {option}
            </button>
          );
        }
        return (
          <button
            key={option}
            className="btn btn-neutral"
            onClick={() => setActive(option)}
          >
            {option}
          </button>
        );
      })}

      {validValues && validValues.length > 1 && (
        <div className="w-full flex justify-end">
          <button className="btn btn-error btn-circle" onClick={clearFilter}>
            <IconX />
          </button>
        </div>
      )}
    </div>
  );
};

export default MultiFilter;
